import { lazy } from 'react';
import { makeStepsIndexesMap } from '@features/Tutorial/utils';

const createStep = <T extends { default: React.ComponentType }>(
  importer: () => Promise<T>,
) => ({
  Component: lazy(importer),
  preload: importer,
});

const stepEntries = {
  StartStep: createStep(() => import('./StartStep')),
  BalanceStep: createStep(() => import('./BalanceStep')),
  TicketStep: createStep(() => import('./TicketStep')),
  BetStep: createStep(() => import('./BetStep')),
  StartGameStep: createStep(() => import('./StartGameStep')),
  GameStep: createStep(() => import('./GameStep')),
  LuckyNumbStep: createStep(() => import('./LuckyNumbStep')),
  GameTimeStep: createStep(() => import('./GameTimeStep')),
  WinningNumbStep: createStep(() => import('./WinningNumbStep')),
  ResultGameStep: createStep(() => import('./ResultGameStep')),
  GameWinnersStep: createStep(() => import('./GameWinnersStep')),
  GameJettonsStep: createStep(() => import('./GameJettonsStep')),
  JackpotTabStep: createStep(() => import('./JackpotTabStep')),
  LeaguesStep: createStep(() => import('./LeaguesStep')),
  LeaguesJackpotStep: createStep(() => import('./LeaguesJackpotStep')),
  MyTabStep: createStep(() => import('./MyTabStep')),
  TotalWinningStep: createStep(() => import('./TotalWinningStep')),
  JackpotTicketStep: createStep(() => import('./JackpotTicketsStep')),
  JackpotHistoryStep: createStep(() => import('./JackpotHistoryStep')),
  EndTutorialStep: createStep(() => import('./EndTutorialStep')),
};

export const steps = Object.fromEntries(
  Object.entries(stepEntries).map(([key, { Component }]) => [key, Component]),
) as { [K in keyof typeof stepEntries]: (typeof stepEntries)[K]['Component'] };

export const stepsIndexes = makeStepsIndexesMap(steps);
const stepEntriesList = Object.values(stepEntries);

export const stepsList = stepEntriesList.map(({ Component }) => Component);
export const preloadStep = (index: number) => stepEntriesList[index]?.preload();
